module.exports = __webpack_public_path__ + "static/opening-9ebe2c09d43b67ce4cfa5c47bd9bdaff.mp4";